import PillRefining from './PillRefining.vue';
import TreasureRefining from './TreasureRefining.vue';

export { PillRefining, TreasureRefining };
